import { render, staticRenderFns } from "./HevrutaPage.vue?vue&type=template&id=0a210dc0&"
import script from "./HevrutaPage.vue?vue&type=script&lang=js&"
export * from "./HevrutaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports